import * as React from 'react';
import * as style from './style.css';
import { Tooltip } from '@cian/ui-kit';
import { IconProduct3DTour16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export const Features = _ref => {
  let {
    features
  } = _ref;
  if (features.length === 0) {
    return null;
  }
  const feature3D = features.find(feature => feature.type === '3d');
  if (!feature3D) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    children: /*#__PURE__*/_jsx("div", {
      className: style['feature'],
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        title: feature3D.description,
        children: /*#__PURE__*/_jsx(IconProduct3DTour16, {
          color: "icon-inverted-default"
        })
      })
    })
  });
};